const faqs = [
  {
    q: '51影院的影视资源来自哪里？',
    a: '51影院聚合了奇优影院、97影院、窝窝影院、第九影院等全网热门影视站点的资源，通过智能调度系统为用户提供高清流畅的观影服务。所有内容均来自公开网络资源，我们仅做聚合与导航。',
  },
  {
    q: '需要下载App或安装播放器吗？',
    a: '不需要。51影院为纯网页端平台，支持所有主流浏览器访问，电脑、手机、平板均可直接在线观看，无需下载任何App或安装第三方播放器插件。',
  },
  {
    q: '影片画质怎么样？会卡顿吗？',
    a: '平台采用高速CDN加速与智能码率适配技术，支持最高1080P高清画质。在网络良好的情况下，影片播放流畅不卡顿。系统会根据你的网络状况自动优化播放体验。',
  },
  {
    q: '更新速度有多快？最新电影什么时候上线？',
    a: '我们的内容团队每日同步全网最新资源，热门影视上线后通常在24-48小时内即可在51影院找到高清片源。热播电视剧和综艺节目基本做到当天同步更新。',
  },
  {
    q: '支持哪些类型的影视内容？',
    a: '51影院覆盖最新电影、热播电视剧、热门综艺、人气动漫、高分纪录片、经典港片、韩剧日剧等全品类内容，从动作大片到治愈动漫，总有一款适合你。',
  },
  {
    q: '观看需要付费吗？如何支持平台？',
    a: '51影院目前所有内容均可免费在线观看。如果你喜欢我们的服务，欢迎将本站推荐给更多朋友，也可以通过「联系我们」渠道提供宝贵的意见反馈，帮助我们做得更好。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-question-line"></i>常见问题
          </span>
          <h2 className="font-heading text-[28px] md:text-4xl text-foreground-950 mb-3">常见问题解答</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            关于51影院的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq) => (
            <div key={faq.q} className="bg-background-100 rounded-xl p-5 md:p-6">
              <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-2">{faq.q}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}